import React, { useState } from 'react';
import { Box, Container, Tab as Aba, Tabs } from '@mui/material';

// Componente aba
function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box>
            {children}
          </Box>
        )}
      </div>
    );
  }
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }


const Tab = ({ corpo, cabe }) => {
    const [pagina, setPagina ] = useState(0);
    
    return (
        <Container disableGutters disablePadding >
            
            <Tabs 
              variant="scrollable"
              scrollButtons
              allowScrollButtonsMobile
              
              value={pagina} onChange={(evt, valor)=> setPagina(valor)}>
                {cabe.map((ele,idx)=>(
                    <Aba label={ele} key={idx} {...a11yProps(idx)} />
                ))}
            </Tabs>
            
            {corpo.map((ele,idx)=>(
                <TabPanel value={pagina} key={idx} index={idx}>
                    {ele}                
                </TabPanel>
            ))}
        </Container>
    )
  
}

export default Tab;